/* ver 1.2.1 */

import * as THREE from "three";

export function Utilities(unify) {
  // Degrees to radians
  this.degToRad = degrees => {
    let rad = degrees * (3.1415 / 180);
    return rad;
  };
  // Degrees to radians returns Vector3
  this.degToRadVec3 = (xDegrees, yDegrees, zDegrees) => {
    let rad = new THREE.Vector3(xDegrees, yDegrees, zDegrees);
    rad *= 3.1415 / 180;
    return rad;
  };

  // Increment String
  this.incrementString = str => {
    // Find the trailing number or it will match the empty string
    var count = str.match(/\d*$/);

    // Take the substring up until where the integer was matched
    // Concatenate it to the matched count incremented by 1
    return str.substr(0, count.index) + ++count[0];
  };

  // Lerp
  this.lerp = (value1, value2, amount) => {
    amount = amount < 0 ? 0 : amount;
    amount = amount > 1 ? 1 : amount;
    return value1 + (value2 - value1) * amount;
  };

  // Name from path
  this.nameFromPath = str => {
    let newName = str.substring(str.lastIndexOf("/") + 1, str.lastIndexOf(".")); // +1 WHY?
    return newName;
  };

  this.clamp = (val, min, max) => {
    return Math.min(Math.max(min, val), max);
  };
}
